"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var css_1 = require("@uifabric/utilities/lib/css");
var NavigationView_styles_1 = require("./NavigationView.styles");
var NavigationView_classNames_1 = require("./NavigationView.classNames");
var NavigationViewMenuItem = /** @class */ (function (_super) {
    __extends(NavigationViewMenuItem, _super);
    function NavigationViewMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this._onClick = function (e) {
            if (_this.props.item.onClick) {
                _this.props.item.onClick(e, _this.props.item);
                if (_this.props.onClickItem) {
                    _this.props.onClickItem(e, _this.props.item);
                }
            }
            else if (_this.props.item.subMenuProps) {
                _this.setState({ menuOpen: !_this.state.menuOpen });
            }
        };
        _this._onRef = function (ref) {
            _this._ref = ref;
        };
        _this._onDismiss = function () {
            _this.setState({ menuOpen: false });
        };
        _this.state = { menuOpen: false };
        return _this;
    }
    NavigationViewMenuItem.prototype.render = function () {
        var item = this.props.item;
        return (React.createElement("div", { role: "menuitem", className: this.props.classNames.menuItemContainer, ref: this._onRef },
            React.createElement("button", { key: item.key, type: "button", disabled: item.disabled, className: css_1.css(this.props.classNames.menuItem, { active: item.checked }), title: this.props.open ? undefined : item.name, onClick: this._onClick },
                React.createElement("div", { className: this.props.classNames.menuItemIconContainer }, item.iconProps ? React.createElement(Icon_1.Icon, __assign({}, item.iconProps)) : !this.props.open ? React.createElement("div", { className: this.props.classNames.menuItemIconAlt }, item.name) : undefined),
                this.props.open && (React.createElement("div", { className: this.props.classNames.menuItemTitleContainer }, item.name))),
            this.state.menuOpen && (React.createElement(ContextualMenu_1.ContextualMenu, __assign({}, this.props.item.subMenuProps, { isBeakVisible: true, directionalHint: 12 /* rightCenter */, target: this._ref, onDismiss: this._onDismiss })))));
    };
    return NavigationViewMenuItem;
}(React.Component));
var NavigationViewMenuControl = /** @class */ (function (_super) {
    __extends(NavigationViewMenuControl, _super);
    function NavigationViewMenuControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavigationViewMenuControl.prototype.render = function () {
        return (React.createElement("button", { type: "button", className: this.props.classNames.menuItem, onClick: this.props.onClick, title: this.props.open ? "Close Menu" : "Open Menu" },
            React.createElement("div", { className: this.props.classNames.menuItemIconContainer },
                React.createElement(Icon_1.Icon, { iconName: "GlobalNavButton" })),
            this.props.open && (React.createElement("div", { className: this.props.classNames.menuItemTitleContainer }, this.props.title))));
    };
    return NavigationViewMenuControl;
}(React.Component));
var NavigationView = /** @class */ (function (_super) {
    __extends(NavigationView, _super);
    function NavigationView(props) {
        var _this = _super.call(this, props) || this;
        _this._onMainMouseDown = function () {
            if (_this.menuOpen) {
                _this.menuOpen = false;
            }
        };
        _this._onClickControl = function () {
            _this.menuOpen = !_this.menuOpen;
        };
        _this._onMenuItemClicked = function (e, item) {
        };
        _this._renderMenuItem = function (item, idx) {
            return React.createElement(NavigationViewMenuItem, { item: item, key: item.key, open: _this.state.menuOpen, classNames: _this._classNames, onClickItem: _this._onMenuItemClicked });
        };
        _this._notifyMenuOpenChange = function () {
            if (_this.props.onMenuOpenChange && !_this.state.menuTransition && !_this.state.mainTransition) {
                _this.props.onMenuOpenChange(_this.state.menuOpen);
            }
        };
        _this._onMenuTransitionEnd = function () {
            _this.setState({ menuTransition: false }, _this._notifyMenuOpenChange);
        };
        _this._onMainTransitionEnd = function () {
            _this.setState({ mainTransition: false }, _this._notifyMenuOpenChange);
        };
        _this.state = { menuOpen: _this.props.menuOpen !== undefined ? _this.props.menuOpen : false, menuTransition: false, mainTransition: false };
        return _this;
    }
    NavigationView.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.menuOpen !== undefined && nextProps.menuOpen !== this.state.menuOpen) {
            this.menuOpen = nextProps.menuOpen;
        }
    };
    Object.defineProperty(NavigationView.prototype, "menuOpen", {
        get: function () {
            return this.state.menuOpen;
        },
        set: function (value) {
            this.setState({ menuOpen: value, menuTransition: true, mainTransition: this.props.menuInline ? true : false });
        },
        enumerable: true,
        configurable: true
    });
    NavigationView.prototype._renderMenuControl = function () {
        return React.createElement(NavigationViewMenuControl, { open: this.state.menuOpen, title: this.props.title, classNames: this._classNames, onClick: this._onClickControl });
    };
    NavigationView.prototype._renderMenuContentNear = function () {
        var items = this.props.items;
        if (items && items.length > 0) {
            var itemViews = items.map(this._renderMenuItem);
            return (React.createElement("div", { className: this._classNames.menuContentNear }, itemViews));
        }
        return null;
    };
    NavigationView.prototype._renderMenuContentFar = function () {
        var items = this.props.farItems;
        if (items && items.length > 0) {
            var itemViews = items.map(this._renderMenuItem);
            return (React.createElement("div", { className: this._classNames.menuContentFar }, itemViews));
        }
        return null;
    };
    Object.defineProperty(NavigationView.prototype, "hasMenu", {
        get: function () {
            return (this.props.items && this.props.items.length > 0) || (this.props.farItems && this.props.farItems.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    NavigationView.prototype._renderMenu = function () {
        if (this.hasMenu) {
            return (React.createElement("nav", { role: "menubar", className: css_1.css(this._classNames.menu, { open: this.state.menuOpen, inline: this.props.menuInline, rootView: this.props.root }), onTransitionEnd: this._onMenuTransitionEnd, "aria-expanded": this.state.menuOpen && !this.state.menuTransition },
                React.createElement("div", { className: this._classNames.menuGlass }),
                React.createElement("div", { className: css_1.css(this._classNames.menuContent) },
                    this._renderMenuControl(),
                    this._renderMenuContentNear(),
                    this._renderMenuContentFar())));
        }
        return null;
    };
    NavigationView.prototype._renderMain = function () {
        return (React.createElement("div", { role: "main", className: css_1.css(this._classNames.main, { menuInlineOffset: this.state.menuOpen && this.props.menuInline, hasMenu: this.hasMenu, rootView: this.props.root }), onMouseDown: !this.props.menuInline ? this._onMainMouseDown : undefined, onTransitionEnd: this.props.menuInline ? this._onMainTransitionEnd : undefined }, this.props.children));
    };
    NavigationView.prototype.render = function () {
        this._classNames = NavigationView_classNames_1.getClassNames(NavigationView_styles_1.getStyles(null, this.props.styles), this.props.className);
        return (React.createElement("div", { className: css_1.css(this._classNames.root, { menuOpen: this.state.menuOpen, rootView: this.props.root }) },
            this._renderMenu(),
            this._renderMain()));
    };
    return NavigationView;
}(React.Component));
exports.NavigationView = NavigationView;
